/*
 * @Author: zhao - 🍉
 * @Date: 2022-02-14 20:54:50
 * @LastEditTime: 2022-02-14 23:28:39
 * @LastEditors: zhao - 🍉
 * @Description: 收房合同房租周期 - 列表
 * @FilePath: /zhzj-admin/src/page/RentCycle/index.jsx
 */
import React, { useRef } from 'react'
import TableHelper from '../../components/TableHelper'
import RentCycleUpdate from './update'
import PageWrap from '../../components/PageWrap';
import QueryString from 'qs';
import { Divider, message, Popconfirm } from 'antd';
import AuthButton from "../../components/AuthButton/AuthButton";
import {fetchDeviceDelete, fetchDeviceList} from "../../services/device";
import {formatTime} from "../../utils";
const RentCycle = (props) => {
    let RentCycleUpdateRef = useRef()
    const TableHelperRef = useRef()
    const { merchantId } = QueryString.parse(props.location.search, { ignoreQueryPrefix: true })

    const handleEdit = (id) => {
        RentCycleUpdateRef.open(merchantId,id).then(() => {
            TableHelperRef.current.postDataSource()
        })
    }
    const handleDelete = (id) => {
        fetchDeviceDelete({ id: id }).then(() => {
            message.success('删除成功')
            TableHelperRef.current.postDataSource()
        })
    }
    const columns = [
        { title: '设备品类', dataIndex: 'deviceCategory'},
        { title: '设备名称', dataIndex: 'deviceModel'},
        { title: '保修开始日期', dataIndex: 'repairStartDate',render: text => formatTime(text, 'YYYY-MM-DD')  },
        { title: '保修结束日期', dataIndex: 'repairEndDate',render: text => formatTime(text, 'YYYY-MM-DD') },
        { title: '租金', dataIndex: 'rent'},
        { title: '创建时间', dataIndex: 'createTime',render: text => formatTime(text, 'YYYY-MM-DD HH:mm')  },
        { title: '修改时间', dataIndex: 'updateTime',render: text => formatTime(text, 'YYYY-MM-DD HH:mm') },
        { title: '操作', dataIndex: 'action', render: (text, record) => {
            return (
                <React.Fragment>
                    <Divider type="vertical" />
                    <a onClick={() => handleEdit(record.id)}>查看详情</a>
                    <Divider type="vertical" />
                    <Popconfirm title="确认删除吗" onConfirm={() => handleDelete(record.id)}>
                        <a >删除</a>
                    </Popconfirm>
                </React.Fragment>
            )
        }}
    ]

    const parseRequestData = (data) => {
        return {...data, merchantId: merchantId}
    }
    const parseResponse = (data) => {
        return { total: data.length, dataSource: data }
    }
    return (
        <PageWrap>
            <div className="search-wrapper">
                <div className="search-btn-list">
                    <AuthButton  authkey="b-2-1" type="primary" icon="plus" onClick={() => handleEdit(null) }>新增</AuthButton>
                </div>
            </div>
            <TableHelper
                ref={TableHelperRef}
                columns={columns}
                parseRequestData={parseRequestData}
                parseResponse={parseResponse}
                request={fetchDeviceList}
            />
            <RentCycleUpdate  getRef={ref => RentCycleUpdateRef = ref} />
        </PageWrap>
    )
}

export default RentCycle



// WEBPACK FOOTER //
// ./src/page/Device/index.jsx